module.exports = __webpack_public_path__ + "img/circle-o.561732bc.svg";